var _circle, _circle2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlatinumBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 27,
    r: 24,
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 27,
    r: 24,
    fill: "url(#paint1_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 27,
    r: 24,
    fill: "#33CCED",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0002,
    cy: 27,
    r: 19.76,
    fill: "url(#paint2_linear)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0002,
    cy: 27,
    r: 19.76,
    fill: "url(#paint3_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0002,
    cy: 27,
    r: 19.76,
    fill: "#33CCED",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dddii)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3332 13.3314C23.5912 12.8892 24.2356 12.8896 24.493 13.3321L28.0443 19.4365L31.1812 24.8286L37.8693 36.325C38.1267 36.7675 37.8043 37.3203 37.2887 37.32L30.5863 37.3156L23.8971 37.3112L18.5326 37.3077C18.0171 37.3073 17.6953 36.7542 17.9534 36.312L20.5436 31.8731C20.6634 31.6679 20.8845 31.5415 21.1238 31.5417L27.211 31.5457C27.6674 31.546 27.9722 31.1129 27.8576 30.7065C27.8428 30.6538 27.8212 30.6016 27.7916 30.5508L27.2758 29.664L24.4853 24.8675C24.244 24.4528 23.663 24.4263 23.3785 24.7886C23.3595 24.8129 23.3417 24.8389 23.3255 24.8668L22.9142 25.5715L20.2248 30.1804C20.105 30.3856 19.8838 30.512 19.6446 30.5118L14.47 30.5084C13.9545 30.508 13.6327 29.9549 13.8907 29.5128L16.6297 24.819L23.3332 13.3314Z",
    fill: "url(#paint4_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3332 13.3314C23.5912 12.8892 24.2356 12.8896 24.493 13.3321L28.0443 19.4365L31.1812 24.8286L37.8693 36.325C38.1267 36.7675 37.8043 37.3203 37.2887 37.32L30.5863 37.3156L23.8971 37.3112L18.5326 37.3077C18.0171 37.3073 17.6953 36.7542 17.9534 36.312L20.5436 31.8731C20.6634 31.6679 20.8845 31.5415 21.1238 31.5417L27.211 31.5457C27.6674 31.546 27.9722 31.1129 27.8576 30.7065C27.8428 30.6538 27.8212 30.6016 27.7916 30.5508L27.2758 29.664L24.4853 24.8675C24.244 24.4528 23.663 24.4263 23.3785 24.7886C23.3595 24.8129 23.3417 24.8389 23.3255 24.8668L22.9142 25.5715L20.2248 30.1804C20.105 30.3856 19.8838 30.512 19.6446 30.5118L14.47 30.5084C13.9545 30.508 13.6327 29.9549 13.8907 29.5128L16.6297 24.819L23.3332 13.3314Z",
    fill: "url(#paint5_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3332 13.3314C23.5912 12.8892 24.2356 12.8896 24.493 13.3321L28.0443 19.4365L31.1812 24.8286L37.8693 36.325C38.1267 36.7675 37.8043 37.3203 37.2887 37.32L30.5863 37.3156L23.8971 37.3112L18.5326 37.3077C18.0171 37.3073 17.6953 36.7542 17.9534 36.312L20.5436 31.8731C20.6634 31.6679 20.8845 31.5415 21.1238 31.5417L27.211 31.5457C27.6674 31.546 27.9722 31.1129 27.8576 30.7065C27.8428 30.6538 27.8212 30.6016 27.7916 30.5508L27.2758 29.664L24.4853 24.8675C24.244 24.4528 23.663 24.4263 23.3785 24.7886C23.3595 24.8129 23.3417 24.8389 23.3255 24.8668L22.9142 25.5715L20.2248 30.1804C20.105 30.3856 19.8838 30.512 19.6446 30.5118L14.47 30.5084C13.9545 30.508 13.6327 29.9549 13.8907 29.5128L16.6297 24.819L23.3332 13.3314Z",
    fill: "#33CCED",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii",
    x: 0.265,
    y: 2.91833,
    width: 49.47,
    height: 48.8167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.326667,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.407843 0 0 0 0 0.486275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.326667,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.040625 0 0 0 0 0.407063 0 0 0 0 0.4875 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.408333,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.407843 0 0 0 0 0.486275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.49,
    dy: -0.0816667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.407843 0 0 0 0 0.486275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii",
    x: 4.8319,
    y: 7.15832,
    width: 40.4183,
    height: 39.9283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.408333,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.294118 0 0 0 0 0.431373 0 0 0 0 0.533333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.49,
    dy: -0.0816667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.04167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.294118 0 0 0 0 0.431373 0 0 0 0 0.533333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dddii",
    x: 1.5498,
    y: 0.75,
    width: 48.66,
    height: 48.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0522396 0 0 0 0 0.573037 0 0 0 0 0.7375 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.326667,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.407843 0 0 0 0 0.486275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.326667,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.040625 0 0 0 0 0.407063 0 0 0 0 0.4875 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.408333,
    dy: 0.326667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.407843 0 0 0 0 0.486275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.408333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect5_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.49,
    dy: -0.0816667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.407843 0 0 0 0 0.486275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect4_innerShadow",
    result: "effect5_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3,
    y1: 5,
    x2: 47,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 7.72414,
    y1: 5.58621,
    x2: 47.8621,
    y2: 47.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 6.8869,
    y1: 8.88666,
    x2: 43.1136,
    y2: 45.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC3CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.7764,
    y1: 9.3693,
    x2: 43.8233,
    y2: 43.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 14.8065,
    y1: 14.0133,
    x2: 37.0993,
    y2: 36.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 17.1843,
    y1: 14.3103,
    x2: 37.5266,
    y2: 35.4824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlatinumBadge);
export default __webpack_public_path__ + "static/media/IconPlatinumBadge.177bf78f.svg";
export { ForwardRef as ReactComponent };